import { useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import JsonView from "@uiw/react-json-view";

import type { ExibirTaskResponse } from "../../model/exibirTaskResponse";

type TarefaCardPropsContent = {
	data: ExibirTaskResponse;
	onClick?: () => void;
	skeleton?: never;
};

type TarefaCardPropsSkeleton = {
	data?: never;
	onClick?: never;
	skeleton: true;
};

type TarefaCardProps = TarefaCardPropsContent | TarefaCardPropsSkeleton;

export default function TarefaCard(props: TarefaCardProps) {
	const [json, setJSON] = useState<{ payloadRequest: boolean; payloadResponse: boolean }>({ payloadRequest: false, payloadResponse: false });

	const formatHeaders = (headers?: string[][] | null) => {
		if (!headers || headers.length === 0) return null;

		return headers.map(([key, value]) => `${key}: ${value}`).join("\n");
	};

	return (
		<Card className="mb-3">
			<Card.Body>
				<Row>
					<Col md={4} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>ID</div>
						<div className={`fw-light  ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`}>{props.data?.id ?? "..."}</div>
					</Col>
					<Col md={4} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>Data Hora Início</div>
						<div className={`fw-light  ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`}>{props.data?.dataInicio ?? "..."}</div>
					</Col>
					<Col md={4} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>Data Hora Fim</div>
						<div className={`fw-light  ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`}>{props.data?.dataFim ?? "..."}</div>
					</Col>
					<Col md={4} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>Timeout</div>
						<div className={`fw-light  ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`}>{props.data?.timeout ?? "..."}</div>
					</Col>
					<Col md={4} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>Latência</div>
						<div className={`fw-light  ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`}>{props.data?.latencia ?? "..."}</div>
					</Col>
					<Col md={4} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>Status</div>
						<div className={`fw-light  ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`}>{props.data?.statusResponse ?? "..."}</div>
					</Col>
					<Col md={4} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>Método</div>
						<div className={`fw-light  ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`}>{props.data?.metodo ?? "..."}</div>
					</Col>
					<Col md={4} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>Condições</div>
						<div className={`fw-light  ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`}>{props.data?.condicoes ?? "..."}</div>
					</Col>
					<Col md={4} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>Sucesso</div>
						<div className={`fw-light  ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`}>{props.data?.sucesso ? "Sim" : "Não"}</div>
					</Col>
					<Col md={12} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>URL</div>
						<div className={`fw-light  ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`}>{props.data?.url ?? "..."}</div>
					</Col>
					<Col md={12} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>Headers Request</div>
						<pre className={`fw-light mb-0 ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`} style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
							{formatHeaders(props.data?.headersRequest) ?? "..."}
						</pre>
					</Col>
					<Col md={12} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>
							Payload Request
							{props.data?.payloadRequest && (
								<Button
									variant="outline-secondary"
									size="sm"
									className="py-0 ms-2"
									onClick={() => {
										setJSON({ ...json, payloadRequest: !json.payloadRequest });
									}}
								>
									{json.payloadRequest ? "JSON" : "STRING"}
								</Button>
							)}
						</div>
						<pre className={`fw-light mb-0 ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`} style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
							{!json.payloadRequest && <>{props.data?.payloadRequest ?? "..."}</>}
							{json.payloadRequest && props.data?.payloadRequest && <JsonView displayDataTypes={false} displayObjectSize={false} value={JSON.parse(props.data.payloadRequest)} />}
						</pre>
					</Col>
					<Col md={12} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>Headers Response</div>
						<pre className={`fw-light mb-0 ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`} style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
							{formatHeaders(props.data?.headersResponse) ?? "..."}
						</pre>
					</Col>
					<Col md={12} className="mb-3">
						<div className={`fw-lighter ${props.skeleton ? "skeleton skeleton-text skeleton-text-title" : ""}`}>
							Payload Response
							{props.data?.payloadResponse && (
								<Button
									variant="outline-secondary"
									size="sm"
									className="py-0 ms-2"
									onClick={() => {
										setJSON({ ...json, payloadResponse: !json.payloadResponse });
									}}
								>
									{json.payloadResponse ? "JSON" : "STRING"}
								</Button>
							)}
						</div>
						<pre className={`fw-light mb-0 ${props.skeleton ? "skeleton skeleton-text skeleton-text-content" : ""}`} style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
							{!json.payloadResponse && <>{props.data?.payloadResponse ?? "..."}</>}
							{json.payloadResponse && props.data?.payloadResponse && <JsonView displayDataTypes={false} displayObjectSize={false} value={JSON.parse(props.data.payloadResponse)} />}
						</pre>
					</Col>
				</Row>
			</Card.Body>
		</Card>
	);
}
